import React from 'react';
import bespokeServerAppMockups2Html from './bespokeServerAppMockups2Html';

const BespokeServerAppMockups2: React.FC = () => {
  return (
    <iframe
      srcDoc={bespokeServerAppMockups2Html}
      title="Bespoke Server App — Style Explorations II"
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
  );
};

export default BespokeServerAppMockups2;
